// Validação do DSN do Sentry — lógica PURA, sem SDK (mesma doutrina do
// sentryDedupe ao lado).
//
// POR QUE ISTO EXISTE, e por que aqui o erro custa mais caro que no PostHog:
// o Sentry é a ÚNICA ferramenta que enxerga o WebView nativo — 70-85% do
// produto (task b48e957d). Se o DSN esvaziar, perde-se a última janela para a
// maioria dos usuários, e o PostHog não serve de rede porque já está cego lá.
// O aviso de DSN ausente era DEV-only: exatamente o bug que deixou o app
// nativo mudo no PostHog por meses sem ninguém saber.
//
// A REGEX É DELIBERADAMENTE FROUXA: `https://<key>@<host>/<id>` é a forma de
// todo DSN do Sentry (cloud e self-host, com ou sem prefixo de caminho). Ela
// existe para separar "vazio ou marcador de template" de "DSN de verdade" —
// não para auditar o DSN. Ver o comentário de initSentry: um `invalid` NÃO
// desliga o Sentry, só grita; quem decide se o DSN presta é o SDK, que sabe
// mais que esta linha e reclama alto sozinho.

export type SentryDsnProblem = "missing" | "invalid";

/** null = DSN plausível; "missing" = ausente/vazio; "invalid" = tem valor mas não é DSN. */
export function sentryDsnProblem(dsn: string | undefined): SentryDsnProblem | null {
  if (!dsn) return "missing";
  if (!/^https?:\/\/[^@\s]+@[^\s/]+\/.+$/.test(dsn)) return "invalid";
  return null;
}
